import * as colors from './colors'

export default { colors }
